'use strict';

/**
 throttle(function, wait, [options])

 Creates and returns a new, throttled version of the passed function,
 that, when invoked repeatedly, will only actually call the original
 function at most once per every wait milliseconds.
 Useful for rate-limiting events that occur faster than you can keep up with.

 By default, throttle will execute the function as soon as you call it for the first time,
 and, if you call it again any number of times during the wait period,
 as soon as that period is over. If you'd like to disable the leading-edge call,
 pass {leading: false}, and if you'd like to disable the execution on the trailing-edge, pass
 {trailing: false}.

 @param {function} function that you want to be throttled
 @param {integer} wait - function will be called at most once per every wait milliseconds.
 @param {object} [options] - custom settings for thorttled function execution
 */
const throttle = [
  '$timeout',

  function ($timeout) {

    function throttle(func, wait, options) {
      var timeoutPromise = null;
      var previous = 0;
      var context;
      var args;
      var result;


      options || (options = {});

      function later() {
        previous = options.leading === false ? 0 : new Date();
        timeoutPromise = null;
        result = func.apply(context, args);
      }

      return function () {
        var now = new Date();
        var remaining;

        if (!previous && options.leading === false) {
          previous = now;
        }
        remaining = wait - (now - previous);
        context = this;
        args = arguments;

        if (remaining <= 0) {
          $timeout.cancel(timeoutPromise);
          timeoutPromise = null;
          previous = now;
          result = func.apply(context, args);
        } else if (!timeoutPromise && options.trailing !== false) {
          timeoutPromise = $timeout(later, remaining);
        }
        return result;
      };
    }

    return throttle;
  }
];

export default throttle;



// WEBPACK FOOTER //
// ./app/src/services/throttle.js